import { Button, FieldWrapper } from '@dixa/lib-shared-habla';
import { HookFormText } from 'lib-shared-hook-form';
import { useFormContext } from 'react-hook-form';

import { OAuthStrategySchemaField } from 'apis/partnerIntegrations/oAuth/types/partnerIntegrationsOAuth.types';

type OAuthProviderConfigurationSchemaFieldProps = {
  field: OAuthStrategySchemaField;
  isCreateMode: boolean;
};

/**
 * A component for rendering an OAuth schema field input.
 *
 * @param field - The field to render.
 * @param isCreateMode - Whether the field is being created or updated.
 * @returns An input field for the OAuth provider configuration.
 */
export const OAuthProviderConfigurationSchemaField = ({
  field,
  isCreateMode,
}: OAuthProviderConfigurationSchemaFieldProps): JSX.Element => {
  const form = useFormContext();
  const formField = form.watch(field.key);

  const { label, key, required, secret: isSecret } = field;

  // For now, all fields are rendered as text inputs
  return formField.isEditing || isCreateMode ? (
    <HookFormText
      label={label}
      name={`${key}.value`}
      rules={{
        required: required ? `${label} is required` : undefined,
      }}
      componentProps={{
        placeholder: `Enter ${label.toLowerCase()}`,
        type: 'text',
        ...(isSecret &&
          !isCreateMode && {
            prefix: {
              type: 'button',
              button: {
                icon: 'close',
                onClick: () => form.setValue(`${key}.isEditing`, false),
              },
            },
          }),
      }}
    />
  ) : (
    <FieldWrapper label={label}>
      <Button
        variant="secondary"
        icon="pen"
        onClick={() => form.setValue(`${key}.isEditing`, true)}
      >
        Update {label}
      </Button>
    </FieldWrapper>
  );
};
